export const NODE_MAINTENANCE_PARTIAL = 'NODE_MAINTENANCE_PARTIAL';
export const NODE_MAINTENANCE_RESET = 'NODE_MAINTENANCE_RESET';
